export const saveUtmParams = () => {
    const params = new URLSearchParams(window.location.search);
    const utmKeys = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_term",
        "placement"
    ];

    const clean = (value) => {
        if (!value) return "";
        return value.replace(/[{]+|[}]+/g, ""); // удаляем все фигурные скобки
    };

    let found = false;
    const utmData = {};

    utmKeys.forEach(key => {
        const raw = params.get(key);
        if (raw) {
            utmData[key] = clean(raw);
            found = true;
        }
    });

    if (found) {
        localStorage.setItem("utm_data", JSON.stringify(utmData));
    }
};